import { createSlice } from '@reduxjs/toolkit';

import { IUserResponse } from '@/types/users';

export interface IUsersReducer {
  users: IUserResponse;
}

const initialState = {
  users: {
    items: [],
    pagination: {
      page: 1,
      limit: 5,
      totalPages: 1,
    },
  },
} as unknown as IUsersReducer;

export const usersSlice = createSlice({
  name: 'users',
  initialState,
  reducers: {
    setUsers: (state, action) => {
      state.users = action.payload;
    },
    updateUserInList: (state, action) => {
      const newUser = action.payload;
      state.users.items = state.users.items.map(user =>
        user.referenceId === newUser.referenceId
          ? newUser
          : user
      );
    },
    deleteUserFromList: (state, action) => {
      const referenceId = action.payload;
      state.users.items = state.users.items.filter(user => user.referenceId !== referenceId);
    },
  },
});

export const { setUsers, updateUserInList, deleteUserFromList } = usersSlice.actions;
